import React from "react";
import { Outlet } from "react-router";
import { StyledContainer } from "customStyled";

const PublicLayout = ({ children }) => {
  return (
    <React.Fragment>
      <StyledContainer direction="column" sx={{ justifyContent: "space-between" }}>
        <Outlet />
      </StyledContainer>
      {/* <Footer /> */}
    </React.Fragment>
  );
};

export default PublicLayout;
